import React from "react";

/* Paleta corporativa Daiichi Sankyo (única fuente de colores en JS) */
export const COLORS = {
	blue: "#005BAA", // primario
	lightBlue: "#00B4ED", // informativo / pendiente
	green: "#89BA17", // hecho / correcto
	gray: "#4D4F53", // texto / inactivo
	yellow: "#FFE900" // acento
};

/** "#RRGGBB" + alpha → "rgba(r,g,b,a)" para fondos suaves */
export function tint(hex, alpha) {
	const n = parseInt(hex.slice(1), 16);
	const r = (n >> 16) & 255;
	const g = (n >> 8) & 255;
	const b = n & 255;
	return `rgba(${r},${g},${b},${alpha})`;
}

/** Etiqueta de estado con la paleta corporativa (sustituye a label-light-*) */
export function StateBadge({ color, solid, className, children }) {
	const style = solid
		? { backgroundColor: color, color: "#fff" }
		: { backgroundColor: tint(color, 0.15), color };
	return (
		<span className={`label label-inline ${className || ""}`} style={style}>
			{children}
		</span>
	);
}

/** Textos largos (hasta 500 caracteres): respetan saltos de línea y no se desbordan. */
export const LONG_TEXT_STYLE = {
	whiteSpace: "pre-wrap",
	wordBreak: "break-word",
	maxWidth: "720px"
};
